import { render, staticRenderFns } from "./ExportAuditsExcel.vue?vue&type=template&id=35cdb6ba&scoped=true&"
import script from "./ExportAuditsExcel.vue?vue&type=script&lang=ts&"
export * from "./ExportAuditsExcel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cdb6ba",
  null
  
)

export default component.exports